<template>
    <div class="mysection">
        <h1>重设密码</h1>
        <div class="login_wx">
          <el-form ref="form" :model="form" :rules="findPasswordRules">
            <el-row>
              <el-col :span="24">
                <el-form-item label=""  prop="newPwd">
                <el-input  v-model="form.newPwd" type="password"  size="large" placeholder="请设置新密码"></el-input>
                </el-form-item>
                <el-row class="el-form-item">
                  <el-col :span="24">
                <el-form-item label=""  prop="affirmPwd">
                <el-input v-model="form.affirmPwd" type="password" size="large" placeholder="请确认新密码"></el-input>
                </el-form-item>
                  </el-col>
                </el-row>
                <!--<el-button   v-on:click="backLong">取消</el-button>-->
               <el-button type="primary" size="large" v-on:click="onSubmit" class="btn_login">确定</el-button>
              </el-col>
            </el-row>
          </el-form>

        </div>
    </div>
</template>
<script>
    import {reqChangePwd} from '../../api/weixin-api'
    export default {
        data(){
            return{
              wxstate:'',
              openid:'',
                form: {
                    newPwd: '',
                    affirmPwd: ''
                },
              findPasswordRules: {
                newPwd: [
                  {required: true, message: '请输入密码', trigger: 'blur'},
                  {
                    pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,
                    message: '密码由字母和数字组成6到16个字符',
                    trigger: 'blur'
                  },
                ],
                affirmPwd: [
                  {required: true,message: '请输入确认密码', trigger: 'blur'},
                ],
              }
            };
        },
        methods:{
            backLong(){
                this.$router.push({name:'login'});
            },
            onSubmit(){
                let that=this;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.$message({
                            message: '请填写符合规则的信息',
                            type: 'warning'
                        });
                        return false;
                    }
                    this.$refs.form.validate((valid) => {
                      if (valid) {
                        reqChangePwd({
                          phoneNumber: that.$route.query.phoneNumber,
                          newPwd:that.form.newPwd,
                          affirmPwd:that.form.affirmPwd,
                        }).then((res)=>{
                          if(res.data.data===1){
                            this.$message({
                              message: '重置成功，请重新登录',
                              type: 'success'
                            });
                            this.$router.push({name:'wxLogin',query:{openid:this.openid,state:this.wxstate}});
                          }else if(res.data.code===3){
                            this.$message({
                              message: '两次密码输入不一致,请重新输入',
                              type: 'error'
                            });
                            that.form.newPwd='';
                            that.form.affirmPwd='';
                          }else {
                            this.$message({
                              message: '重置失败',
                              type: 'error'
                            });
                          }
                        })
                      }
                    });


                }).catch(() => {
                    // something went wrong (non-validation related).
                });

            },
          backForgetPassword:function(openid,wxstate) {
            pushHistory();
            function bodyScroll(){
              window.location.href='/wxForgetPassword?openid='+openid+'&wxstate='+wxstate;
              window.removeEventListener("popstate", bodyScroll,false);
            }
            window.addEventListener("popstate",bodyScroll, false);
            function pushHistory() {
              var state = {
                title: "title",
                url: "#"
              };
              window.history.pushState(state, state.title, state.url);
            }
          },

          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
        },
        mounted(){
            this.$store.dispatch('hideHF');
            this.isWechatBrowser();
          this.openid=this.$route.query.openid;
          this.wxstate=this.$route.query.wxstate;
          this.backForgetPassword(this.openid,this.state);
        },
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxChangePwd.vue